import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Card, Divider, Button, Form, Radio, Select } from 'antd';
import './style.css';

import Responsive from './Responsive';
import { useLocation, useNavigate } from 'react-router-dom';
import { createAppointmentRequest, paymentRequest } from './Actions';
import { selectLoading, selectpaymentData } from './Selectors';
import { Content } from 'antd/es/layout/layout';
import CustomSpin from '../CommonSpin';
import { BodyTextKey, BodyTextValue } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const SelectLocation = () => {
    const [radioBtn, setRadioBtn] = React.useState('convinience');
    const [microClinics, setMicroClinics] = React.useState([]);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const history = useHistory();
    const { state } = useLocation();

    const requesting = useSelector(selectLoading);


    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    
    const microClinicDetails = [];

    const addClinicsToState = () => {
        if (microClinics.length === 0) {
            microClinicDetails.value.forEach((item) => {
                setMicroClinics((prev) => [...prev, item.id]);
            });
        }
    };

    const paymentData = useSelector(selectpaymentData);
    
    if(paymentData) {
        const payload = state.payload;
        navigate(('/scheduledetail'), { state: { payload, paymentData } });
    }

    // const validateSelect = (value, callback) => {
    //     if (value === '') {
    //         callback('Please select a Telemedicine center');
    //     } else {
    //         callback();
    //     }
    // };

    const handleSubmit = () => {

        const scheduleData = state.payload.updatedScheduleData.data;
        const item = scheduleData && scheduleData[0];

        let consultationfees;
        let quikdrFees;
        let QuikDrTaxs;
        let totals;
        let BankCharges;
        let FinalAmounts;


        consultationfees = Number(item?.orgfee?.amount);

        if (item?.organisation?.quikdrFeeType === 'Fixed') {
            quikdrFees = Number(item?.organisation?.quikdrFeeAmount);
        } else if (item?.organisation?.quikdrFeeType === 'Variable') {
            quikdrFees = Number(
                consultationfees * (item?.organisation?.quikdrFeeAmount / 100)
            );
        }

        QuikDrTaxs = Number(
            quikdrFees * (item?.organisation?.taxPercent / 100)
        );
        totals = Number(consultationfees + quikdrFees + QuikDrTaxs);
        BankCharges =
            (totals * (Number(item?.organisation?.bankChargePercent) / 100)).toFixed(2);
        FinalAmounts = (Number(totals) + Number(BankCharges)).toFixed(2);

        console.log('FinalAmounts', FinalAmounts, 'consultationfees', consultationfees );
        
        dispatch(createAppointmentRequest(item, state.payload.patientId));
        dispatch(paymentRequest(consultationfees, item));
        // navigate(('/scheduledetail'), { state: { payload } });

        // e.preventDefault();
    };

    const consultChange = (e) => {
        setRadioBtn(e.target.value);
    };

    const selectClinic = (value) => {
        localStorage.setItem('MICROCLINIC', value);
    };

    if (microClinicDetails.value && microClinicDetails.value.length !== 0) {
        addClinicsToState();
    }

    const data = microClinicDetails.value && microClinicDetails.value.map((item) => (
        <Select.Option key={item.id} value={item.id}>
            {`${item.name}, ${item.address}, ${item.locality}`}
        </Select.Option>
    ));

    return (
        <Content>
            <div style={{ padding: 25, fontFamily: 'Roboto' }}>
                <Responsive />
                <Row type="flex" justify="center" align="middle">
                    <Col xs={24} lg={18} md={22}>
                        <Card>
                            <Form form={form} onFinish={handleSubmit}>
                                <Col>
                                    <span style={{ textAlign: 'center' }}>
                                        <BodyTextValue text = {langdata.Youcanconsultthedoctoronlineatyourpointofconvenience ? langdata.Youcanconsultthedoctoronlineatyourpointofconvenience : 'You can consult the doctor online at your point of convenience.'} />
                                    </span>
                                </Col>
                                <Divider />
                                <Col style={{ textAlign: 'center' }} md={24} lg={8}>
                                    <span>
                                        <strong><BodyTextKey text = {langdata.Consultat ? langdata.Consultat : 'Consult at'} /></strong>
                                    </span>
                                </Col>
                                <Col style={{ textAlign: 'justify', margin: '0 auto' }} md={24} lg={16}>
                                    <Form.Item
                                        style={{ width: '100%' }}
                                        name="consultAt"
                                        rules={[{ required: true, message: langdata.Pleaseselectanoption ? langdata.Pleaseselectanoption : 'Please select an option' }]}
                                    >
                                        <Radio.Group value={radioBtn} onChange={consultChange} style={{
                                            marginTop: '2%'
                                        }}>
                                            <Radio value="convinience" style={{ marginBottom: '4%' }}>
                                                <BodyTextValue text = {langdata.FromYourHomeComputerorSmartMobilePhone ? langdata.FromYourHomeComputerorSmartMobilePhone : 'From Your Home Computer or Smart Mobile Phone.'} />
                                            </Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>

                                {radioBtn === 'telemedicine' && (
                                    <div>
                                        <Col md={24} lg={8} style={{ textAlign: 'center', marginTop: '3%' }}>
                                            <span>
                                                <strong>{langdata.SelectTelemedicinecenter ? langdata.SelectTelemedicinecenter : 'Select Telemedicine center' }</strong>
                                            </span>
                                        </Col>
                                        <Col md={24} lg={16} style={{ marginTop: '2%' }}>
                                            <Form.Item
                                                name="microclinic"
                                                initialValue=""
                                                rules={[{ required: true, message: langdata.Pleaseselectamicroclinic ? langdata.Pleaseselectamicroclinic : 'Please select a micro clinic' }]}
                                            >
                                                <Select
                                                    style={{ width: '48%' }}
                                                    value={microClinics}
                                                    onChange={selectClinic}
                                                >
                                                    {data}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </div>
                                )}
                                <Col span={24}>
                                    <Button type="primary" htmlType="submit" style={{ float: 'right' }}>
                                        {langdata.Next ? langdata.Next : 'Next' }
                                    </Button>
                                </Col>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
            <CustomSpin spinning = {requesting} />
        </Content>
    );
};


export default SelectLocation;
